import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { MarkantElementsModule } from '@markant/elements-angular';
import { NgIf } from '@angular/common';

@Component({
  selector: 'markant-platform-section-start-dialog',
  templateUrl: './section-start-dialog.component.html',
  styleUrls: ['./section-start-dialog.component.scss'],
  standalone: true,
  imports: [TranslocoModule, MarkantElementsModule, NgIf],
})
export class SectionStartDialogComponent {
  @Input() tourTranslationKey = '';
  @Input() sectionNumber = -1;

  @Output() cancel: EventEmitter<void> = new EventEmitter<void>();
  @Output() tourStart: EventEmitter<void> = new EventEmitter<void>();

  closeDialog(): void {
    this.cancel.emit();
  }

  startTour(): void {
    this.tourStart.emit();
  }
}
